import { ChangeDetectorRef, Component, ElementRef, OnChanges, SimpleChanges, ChangeDetectionStrategy, inject, output, viewChild } from '@angular/core';
import {MealKitIconButtonComponent} from '@yoni/mealcomponents-lib';
import {ModalService} from '../../../Services/modal.service';

import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CookieService} from 'ngx-cookie-service';
import {QdmService, Restaurant} from '../../../Services/qdm.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'modal-restaurant-infos',
    templateUrl: './ModalRestaurantInfos.component.html',
    styleUrl: "./ModalRestaurantInfos.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MealKitIconButtonComponent, TranslateModule]
})
export class ModalRestaurantInfosComponent implements OnChanges {
  private variables = inject<any>('variables' as any);
  private modalService = inject(ModalService);
  private ref = inject(ElementRef);
  private translate = inject(TranslateService);
  private cookieService = inject(CookieService);
  private sanitizer = inject(DomSanitizer);
  private qdm = inject(QdmService);
  private cdr = inject(ChangeDetectorRef);


  restaurant: Restaurant | null = null;
  closeText: string|null = null;

  currentPage: string = "language";
  readonly messageEvent = output<void>();

  hasUpperCase: boolean = false;
  hasBoldText: boolean = false;

  mapUrl: string = "";

  readonly fadeInContainer = viewChild('fadeInContainer', { read: ElementRef });
  protected message: string = "";

  ngOnInit(): void {
    this.restaurant = this.variables.restaurant;
    this.closeText = this.variables.closeText || null;

    if (this.restaurant) {
      this.qdm.fetchRestaurantById(this.restaurant.id).then(r => {
        let messageFooter: string = r.message_footer;
        if(!messageFooter){
          messageFooter = "";
        }

        this.message = messageFooter;
        this.cdr.detectChanges();
      });

      this.mapUrl = this.safeUrl('https://www.openstreetmap.org/export/embed.html?bbox=' + this.restaurant.longitude + '%2C' + this.restaurant.latitude + '%2C' + this.restaurant.longitude + '%2C' + this.restaurant.latitude + '&layer=mapnik&marker=' + this.restaurant.latitude + '%2C' + this.restaurant.longitude + "&zoom=15")
    }

    this.ref.nativeElement.addEventListener('click', (ev: MouseEvent) => {
      if (ev.target && (ev.target as HTMLElement).classList.contains("clickClose")) {
        this.modalService.close();
      }
    });

    this.hasUpperCase = this.cookieService.check("uppercase");
    this.hasBoldText = this.cookieService.check("boldtext");
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  onCloseClick(): void {
    this.modalService.close();
  }

  generateImageUrl(restaurant: Restaurant): string {
    if (restaurant.logo === "nologo.png") {
      return `${(globalThis as any).env.qdmApiUrl}/upload/logos/nologo.png`;
    }
    return `${(globalThis as any).env.qdmApiUrl}/upload/logos/${restaurant.id}/${restaurant.logo}`;
  }

  formatPhone(num: string): string {
    if (!num || num.length < 8) {
      return num;
    }

    return num.toString().replace(/(\d{2})(?=\d)/g, '$1 ');
  }

  safeUrl(url: string): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  removeFadeInFromContainer() {
    const fadeInContainer = this.fadeInContainer();
    if (!fadeInContainer) {
      return;
    }

    fadeInContainer.nativeElement.classList.remove("fadeIn");
  }

  close(ev: MouseEvent) {
    if (ev.target == ev.currentTarget) {
      this.modalService.close();
    }
  }
}
